const scrollStep = 120;

export { scrollStep };
